import React from 'react';
import ModularAppView from './ModularAppView';

export default function BookmarksApp() {
  return (
    <ModularAppView
      slug="bookmarks"
      defaultTitle="Bookmarks"
      defaultIcon="Bookmark"
      defaultCategory="Productivity"
    />
  );
}
